import IOffers from '~domain/entities/Offers/IOffers';
import { computed, observable, set } from 'mobx';
import Offer from '~domain/entities/Offer/Offer';
import IOffer from '~domain/entities/Offer/IOffer';

export default class Offers implements IOffers {
    @observable private has_error: IOffers['hasError'] = false;
    @observable private is_loading: IOffers['isLoading'] = false;
    @observable private _offers: IOffers['offers'];

    constructor() {}

    @computed
    public get hasError(): IOffers['hasError'] {
        return this.has_error;
    }

    public set hasError(newState: IOffers['hasError']) {
        this.has_error = newState;
    }

    @computed
    public get isLoading(): IOffers['isLoading'] {
        return this.is_loading;
    }

    public set isLoading(newState: IOffers['isLoading']) {
        this.is_loading = newState;
    }

    @computed
    public get offers(): IOffers['offers'] {
        return this._offers;
    }

    public static fromJSON = (data: IOffer[]) => {
        const offers = new Offers();
        const _offers = data.map((offer) => Offer.fromJSON(offer));
        set(offers, { _offers });

        return offers;
    };
}
